import styled from 'styled-components';

export const Container = styled.div`
  color: #e9ecef;
  padding: 20px;
  height: 100%;
  overflow-y: auto;
  &::-webkit-scrollbar-track {
    background-color: #2a3142;
  }
  &::-webkit-scrollbar {
    width: 6px;
    background: #eee;
  }
  &::-webkit-scrollbar-thumb {
    background: #eee;
  }
`;
